"use client";

import {
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import Input from "@/components/ui/Input";
import usePost from "@/hooks/usePost";
import { phoneSchema } from "@/schemas/auth/register";
import { registerUserPhone } from "@/services/register";
import { Button } from "@/ui/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const RegisterPhone = ({ registerId }) => {
  const router = useRouter();
  const { handlePost, isLoading } = usePost(handleRegisterPhone, [], {
    showErrorToast: true,
  });

  const { t } = useTranslation("register");

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(phoneSchema) });

  async function handleRegisterPhone(values) {
    await registerUserPhone(values.phone, registerId);
    const currentQuery = { ...router.query };
    delete currentQuery.byGoogle;
    router.push({
      pathname: router.pathname,
      query: currentQuery,
    });
  }

  // Function to stop event propagation during form submission
  const onDialogSubmit = event => {
    event.stopPropagation(); // This prevents the submission event from affecting other forms
    handleSubmit(handlePost)(event);
  };

  return (
    <>
      <DialogHeader className="sm:text-right">
        <DialogTitle className="text-foreground text-center">
          {t("phone_registration")}
        </DialogTitle>
      </DialogHeader>

      <form onSubmit={onDialogSubmit} className="w-full grid">
        <label className="block">
          <span className="block font-medium">{t("phone_number")}</span>
          <Input
            {...register("phone")}
            dir="ltr"
            type="text"
            errorMessage={t(errors.phone?.message)}
            className="rtl:text-end"
            placeholder={t("phone_number")}
            autoFocus
          />
        </label>

        <DialogFooter>
          <Button isLoading={isLoading} className="w-full mt-4" type="submit">
            {t("continue_button")}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
};

export default RegisterPhone;
